import { GetterTree } from "vuex";
import { RootState } from "../types";
import { InstructorState } from "./types";

export const getters: GetterTree<InstructorState, RootState> = {};
